import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
    Chapter,
    Course,
    CustomerBaseData,
    CustomerDetailsCourseParticipation,
    CustomerDetailsExam,
    CustomerListData,
    LearnModuleType,
    Note,
    Section,
    TimeExpenditure,
} from '@cna/projects/ak-jura/shared/interfaces';
import {
    AlignmentType,
    BorderStyle,
    Document,
    Header,
    HeadingLevel,
    HeightRule,
    HorizontalPositionRelativeFrom,
    ImageRun,
    IStylesOptions,
    Packer,
    Paragraph,
    SectionType,
    Table,
    TableCell,
    TableRow,
    TextRun,
    TextWrappingSide,
    TextWrappingType,
    VerticalAlign,
    VerticalPositionRelativeFrom,
    WidthType,
} from 'docx';
import { saveAs } from 'file-saver';
import _ from 'lodash';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import sanitizeHtml from 'sanitize-html';
import { ModuleDocumentHelperService } from '../../../../projects/ak-jura/angular/shared-components/src/lib/services/module-document-helper.service';
import { LearningModuleDocumentInfo } from '../../../../projects/ak-jura/shared/interfaces/src/lib/learning-module-document-info';
import { NumberToNumberingPipe } from '../../../ui/pipes/src/lib/number-to-numbering.pipe';
import { SecondsToHoursPipe } from '../../../ui/pipes/src/lib/seconds-to-hours.pipe';
import { SectionNumberingPipe } from '../../../ui/pipes/src/lib/section-numbering.pipe';
import { SectionTitlePipe } from '../../../ui/pipes/src/lib/section-title.pipe';

// TODO Move this Service inside AK-Jura Project - to specific!

const MAX_TITLE_DEPTH = 3;

const noBorderConf = {
    top: {
        style: BorderStyle.NONE,
        size: 0,
        color: 'ffffff',
    },
    bottom: {
        style: BorderStyle.NONE,
        size: 0,
        color: 'ffffff',
    },
    left: {
        style: BorderStyle.NONE,
        size: 0,
        color: 'ffffff',
    },
    right: {
        style: BorderStyle.NONE,
        size: 0,
        color: 'ffffff',
    },
};
const topBorderConf = {
    top: {
        style: BorderStyle.SINGLE,
        size: 1,
        color: '000000',
    },
    bottom: {
        style: BorderStyle.NONE,
        size: 0,
        color: 'ffffff',
    },
    left: {
        style: BorderStyle.NONE,
        size: 0,
        color: 'ffffff',
    },
    right: {
        style: BorderStyle.NONE,
        size: 0,
        color: 'ffffff',
    },
};

interface TitleTableRowData {
    numbering: string;
    title: string;
    author: string;
    isChapter: boolean;
}

const img_ak_logo_1 =
    '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';

// Docs -> https://docx.js.org/#/
@Injectable({
    providedIn: 'root',
})
export class DocxCreatorService {
    private approvalNumber = '5111518';

    constructor(
        private http: HttpClient,
        public datepipe: DatePipe,
        private sectionNumberingPipe: SectionNumberingPipe,
        private sectionTitlePipe: SectionTitlePipe,
        private numberToNumberingPipe: NumberToNumberingPipe,
        private secondsToHoursPipe: SecondsToHoursPipe,
        private moduleDocumentHelperService: ModuleDocumentHelperService
    ) {}

    loadImage(url: string): Observable<string | ArrayBuffer> {
        return this.http.get(url, { responseType: 'blob' }).pipe(
            mergeMap(blob => {
                return new Promise<string | ArrayBuffer>((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onloadend = () => {
                        resolve(reader.result);
                    };
                    try {
                        reader.readAsDataURL(blob);
                    } catch (error) {
                        reject(error);
                    }
                });
            })
        );
    }

    public createFromNotes(
        notes: Note[],
        moduleNumber: number | string,
        course: string,
        moduleDocumentInfo?: LearningModuleDocumentInfo
    ) {
        const explicitModuleName = moduleDocumentInfo?.moduleName?.trim();
        const moduleAsString = String(moduleNumber ?? '').trim();
        const isNumericModule =
            typeof moduleNumber === 'number' || /^\d+$/.test(moduleAsString);
        const romanModuleNumber = isNumericModule
            ? this.numberToNumberingPipe.transform(
                  Number(moduleAsString || moduleNumber),
                  'upperRomanNumerals'
              )
            : '';
        const moduleHeading =
            explicitModuleName ||
            (isNumericModule && romanModuleNumber
                ? `Modul ${romanModuleNumber}`
                : moduleAsString || 'Modul');

        const styleNotes: IStylesOptions = {
            default: {
                document: {
                    run: {
                        size: 20,
                        color: '000000',
                        font: 'Adelle Sans Sb',
                    },
                },
                title: {
                    run: {
                        size: 56,
                        bold: true,
                        font: 'Calibri',
                    },
                    paragraph: {
                        spacing: {
                            before: 100,
                            after: 200,
                        },
                    },
                    next: 'subline',
                },
                heading1: {
                    run: {
                        size: 32, // halfPts RTFM!!!!
                        bold: true,
                    },
                    paragraph: {
                        spacing: {
                            before: 100,
                            after: 200,
                        },
                    },
                    next: 'numbering',
                },
                heading2: {
                    run: {
                        size: 24, // halfPts RTFM!!!!
                        bold: true,
                    },
                    paragraph: {
                        spacing: {
                            after: 50,
                        },
                    },
                    next: 'note',
                },
            },
            paragraphStyles: [
                {
                    id: 'subline',
                    name: 'Subline',
                    basedOn: 'Normal',
                    next: HeadingLevel.HEADING_1,
                    run: {
                        italics: true,
                    },
                },
                {
                    id: 'numbering',
                    name: 'Numbering',
                    basedOn: 'Normal',
                    next: HeadingLevel.HEADING_2,
                },
                {
                    id: 'note',
                    name: 'Note',
                    basedOn: 'Normal',
                    next: 'numbering',
                    paragraph: {
                        spacing: {
                            after: 300,
                        },
                    },
                },
            ],
        };

        const documentData = {
            styles: styleNotes,
            sections: [{ headers: {}, children: [] }],
        };

        documentData.sections[0].headers = {
            default: new Header({
                children: [
                    new Paragraph({
                        children: [
                            new ImageRun({
                                data: Uint8Array.from(atob(img_ak_logo_1), c =>
                                    c.charCodeAt(0)
                                ),
                                transformation: {
                                    width: 476.4,
                                    height: 76.8,
                                },
                                floating: {
                                    horizontalPosition: {
                                        relative:
                                            HorizontalPositionRelativeFrom.LEFT_MARGIN,
                                        offset: 900000,
                                    },
                                    verticalPosition: {
                                        relative:
                                            VerticalPositionRelativeFrom.PAGE,
                                        offset: 100000,
                                    },
                                },
                            }),
                        ],
                    }),
                ],
            }),
        };

        documentData.sections[0].children.push(
            new Paragraph({
                text: `Notizen ${course}`,
                heading: HeadingLevel.TITLE,
            })
        );
        documentData.sections[0].children.push(
            new Paragraph({
                text:
                    'Stand ' +
                    this.datepipe.transform(new Date(), 'dd.MM.YYYY'),
                style: 'subline',
            })
        );
        documentData.sections[0].children.push(
            new Paragraph({
                text: moduleHeading,
                heading: HeadingLevel.HEADING_1,
            })
        );
        const hiddenSectionIds = new Set<string>();
        const collectSectionIdsRecursive = (sections?: Section[]) => {
            (sections ?? []).forEach(section => {
                if (!section) {
                    return;
                }
                if (section.id) {
                    hiddenSectionIds.add(String(section.id));
                }
                collectSectionIdsRecursive(section.sections);
            });
        };
        (moduleDocumentInfo?.chapters ?? []).forEach(chapter => {
            if (!chapter?.hidden) {
                return;
            }
            collectSectionIdsRecursive(chapter.sections);
        });
        notes.forEach(note => {
            const isInHiddenChapter = hiddenSectionIds.has(
                String(note?.sectionId ?? '')
            );
            const chapterNumbering = note?.chapterNumbering ?? [];
            const visibleChapterNumbering = isInHiddenChapter
                ? chapterNumbering.slice(1)
                : chapterNumbering;

            if (visibleChapterNumbering.length > 0) {
                documentData.sections[0].children.push(
                    new Paragraph({
                        text:
                            visibleChapterNumbering.length >= 2
                                ? 'Kapitel ' + visibleChapterNumbering.join(' | ')
                                : 'Frage ' + visibleChapterNumbering[0],
                        style: 'numbering',
                    })
                );
            }
            documentData.sections[0].children.push(
                new Paragraph({
                    text: note.title,
                    heading: HeadingLevel.HEADING_2,
                })
            );
            documentData.sections[0].children.push(
                new Paragraph({
                    text: note.description,
                    style: 'note',
                })
            );
        });
        const doc = new Document(documentData);
        const fileName =
            'AK_JURA_Notizen_' + moduleHeading.replace(/\s+/g, '_') + '.docx';
        Packer.toBlob(doc).then(blob => {
            saveAs(blob, fileName);
        });
    }

    extractSalutation(displayName: string): [string, string] {
        if (
            displayName.toLocaleLowerCase().startsWith('herr ') ||
            displayName.toLocaleLowerCase().startsWith('frau ')
        ) {
            const split = displayName.split(' ');
            const salutation = split.shift();
            return [salutation, split.join(' ')];
        }
        return ['', displayName];
    }

    createCustomerNameHeader(customer: CustomerBaseData): Paragraph[] {
        const [salutation, name] = this.extractSalutation(customer.displayName);
        return [
            new Paragraph({
                text: salutation,
                style: 'ak-heading-3',
                spacing: {
                    before: 200,
                },
            }),
            new Paragraph({
                text: name,
                style: 'ak-heading-2',
            }),
        ];
    }

    createSignFooter(): Paragraph[] {
        return [
            new Paragraph({
                children: [new TextRun({ text: `Ralph Schweikert` })],
                spacing: { before: 750 },
                style: 'smallParagraphStyle',
            }),
            new Paragraph({
                children: [
                    new TextRun({
                        text: `Akademie für juristische Fachseminare`,
                    }),
                ],
                style: 'smallParagraphStyle',
            }),
        ];
    }

    createEducationCertificateFrontpageSection(
        customer: CustomerBaseData,
        courseParticipation: CustomerDetailsCourseParticipation
    ): Paragraph[] {
        return [
            new Paragraph({
                children: [
                    new TextRun({
                        text: 'Fachanwaltslehrgang',
                        style: 'ak-heading-1',
                    }),
                    new TextRun({
                        text:
                            typeof courseParticipation.bookedCourse
                                .associatedLegalArea !== 'string'
                                ? courseParticipation.bookedCourse
                                      .associatedLegalArea.name
                                : '',
                        break: 1,
                    }),
                ],
                style: 'ak-heading-1',
                spacing: { before: 4000, after: 600 },
            }),
            ...this.createCustomerNameHeader(customer),
            new Paragraph({
                children: [
                    new TextRun({
                        text:
                            'hat durch die erfolgreiche Teilnahme am Fachanwaltslehrgang der Akademie für juristische Fachseminare (in Kooperation mit der Wolters Kluwer Deutschland GmbH) die erforderlichen besonderen theoretischen Kenntnisse auf dem Gebiet des ' +
                            courseParticipation.bookedCourse.description +
                            's erworben. ',
                    }),
                ],
                style: 'paragraphStyle',
                spacing: { before: 400 },
            }),
            new Paragraph({
                children: [
                    new TextRun({
                        text: `Die nach §§ 4, 14b FAO nachzuweisenden Kenntnisse wurden erfolgreich vermittelt.`,
                    }),
                ],
                style: 'paragraphStyle',
                spacing: { before: 300 },
            }),
            new Paragraph({
                children: [
                    new TextRun({
                        text: `${customer.displayName} hat sämtliche Voraussetzungen zum Erwerb der theoretischen Kenntnisse gemäß der Fachanwaltsordnung erfüllt.`,
                    }),
                ],
                style: 'paragraphStyle',
                spacing: { before: 300 },
            }),
            new Paragraph({
                children: [
                    new TextRun({
                        text: `Ulm, den ${this.datepipe.transform(
                            Date.now(),
                            'dd.MM.yyyy'
                        )} `,
                    }),
                ],
                style: 'smallParagraphStyle',
                spacing: { before: 2950 },
            }),
            ...this.createSignFooter(),
        ];
    }

    createExamTable(courseExam: CustomerDetailsExam): Table {
        const periodRows: TableRow[] = [];
        const tempDateString = '1/1/1970 ';
        courseExam.examinationPeriods.forEach((period, index) => {
            const dateDiff = new Date(
                new Date(tempDateString + period.endTime).getTime() -
                    new Date(tempDateString + period.startTime).getTime()
            );
            const timeDiff =
                this.datepipe.transform(dateDiff, 'h') + ' Zeitstunden';
            periodRows.push(
                new TableRow({
                    height: { value: 500, rule: HeightRule.EXACT },
                    children: [
                        new TableCell({
                            verticalAlign: VerticalAlign.CENTER,
                            borders: topBorderConf,
                            margins: {
                                left: 100,
                            },
                            children: [
                                new Paragraph({
                                    text: index + 1 + '. Klausur',
                                    style: 'exam-table-content',
                                }),
                            ],
                        }),
                        new TableCell({
                            verticalAlign: VerticalAlign.CENTER,
                            borders: topBorderConf,
                            margins: {
                                left: 100,
                            },
                            children: [
                                new Paragraph({
                                    text: this.datepipe.transform(
                                        period.date,
                                        'dd.MM.yyyy'
                                    ),
                                    style: 'exam-table-content',
                                }),
                            ],
                        }),
                        new TableCell({
                            verticalAlign: VerticalAlign.CENTER,
                            borders: topBorderConf,
                            margins: {
                                left: 100,
                            },
                            children: [
                                new Paragraph({
                                    text: timeDiff,
                                    style: 'exam-table-content',
                                }),
                            ],
                        }),
                        new TableCell({
                            verticalAlign: VerticalAlign.CENTER,
                            borders: topBorderConf,
                            margins: {
                                left: 100,
                            },
                            children: [
                                new Paragraph({
                                    text: 'bestanden',
                                    style: 'exam-table-content',
                                }),
                            ],
                        }),
                    ],
                })
            );
        });
        return new Table({
            columnWidths: [2505, 1500, 2500, 1800],
            width: {
                type: WidthType.PERCENTAGE,
                size: 100,
            },
            rows: [
                new TableRow({
                    height: { value: 400, rule: HeightRule.EXACT },
                    children: [
                        new TableCell({
                            verticalAlign: VerticalAlign.CENTER,
                            borders: noBorderConf,
                            margins: {
                                left: 100,
                            },
                            children: [
                                new Paragraph({
                                    text: 'Leistungskontrollen',
                                    style: 'exam-table-header',
                                }),
                            ],
                        }),
                        new TableCell({
                            verticalAlign: VerticalAlign.CENTER,
                            borders: noBorderConf,
                            margins: {
                                left: 100,
                            },
                            children: [
                                new Paragraph({
                                    text: 'Datum',
                                    style: 'exam-table-header',
                                }),
                            ],
                        }),
                        new TableCell({
                            verticalAlign: VerticalAlign.CENTER,
                            borders: noBorderConf,
                            margins: {
                                left: 100,
                            },
                            children: [
                                new Paragraph({
                                    text: 'Bearbeitungszeit',
                                    style: 'exam-table-header',
                                }),
                            ],
                        }),
                        new TableCell({
                            verticalAlign: VerticalAlign.CENTER,
                            borders: noBorderConf,
                            margins: {
                                left: 100,
                            },
                            children: [
                                new Paragraph({
                                    text: 'Ergebnis',
                                    style: 'exam-table-header',
                                }),
                            ],
                        }),
                    ],
                }),
            ].concat(periodRows),
        });
    }

    createEducationCertificateExamSectionStart(
        customer: CustomerBaseData,
        courseExam: CustomerDetailsExam,
        courseParticipation: CustomerDetailsCourseParticipation
    ): Paragraph[] {
        return [
            new Paragraph({
                children: [
                    new TextRun({
                        text: 'Nachweis der schriftlichen Prüfung',
                    }),
                ],
                spacing: { before: 1700, after: 800 },
                style: 'ak-heading-1',
            }),
            ...this.createCustomerNameHeader(customer),
            new Paragraph({
                text: `hat im Rahmen des Fachanwaltslehrgangs der Akademie für juristische Fachseminare (in
Kooperation mit der Wolters Kluwer Deutschland GmbH) besondere Kenntnisse auf dem
Gebiet des ${courseParticipation.bookedCourse.description}s durch die Fertigung folgender Klausuren unter prüfungsmäßigen
Bedingungen gem. § 4a FAO nachgewiesen:`,
                spacing: { before: 600, after: 800 },
                style: 'paragraphStyle',
            }),
        ];
    }

    createEducationCertificateExamSectionEnd(): Paragraph[] {
        return [
            new Paragraph({
                children: [
                    new TextRun({
                        text: 'Die schriftlichen Leistungskontrollen erfüllen die Voraussetzungen nach § 6 Abs.2c der FAO. Als Klausurtyp wurden Fragen und kurze Fälle gestellt, den die Lehrgangsteilnehmer unter Verwendung der einschlägigen Gesetze (ohne Kommentare, Sekundärliteratur, etc.) zu lösen hatten. ',
                    }),
                ],
                spacing: {
                    before: 1000,
                    after: 2800,
                },
                style: 'paragraphStyle',
            }),
            ...this.createSignFooter(),
        ];
    }

    createEducationCertificateLernContentSectionHeader(
        customer: CustomerBaseData,
        courseParticipation: CustomerDetailsCourseParticipation
    ): Paragraph[] {
        return [
            new Paragraph({
                text: 'Nachweis der Lehrinhalte',
                style: 'ak-heading-1',
                spacing: { before: 1700, after: 800 },
            }),
            ...this.createCustomerNameHeader(customer),
            new Paragraph({
                text: `hat durch die erfolgreiche Teilnahme am Fachanwaltslehrgang der Akademie für juristische Fachseminare (in Kooperation mit der Wolters Kluwer Deutschland GmbH) die erforderlichen besonderen theoretischen Kenntnisse auf dem Gebiet des ${
                    typeof courseParticipation.bookedCourse
                        .associatedLegalArea !== 'string'
                        ? courseParticipation.bookedCourse.associatedLegalArea
                              .name
                        : ''
                }s erworben.`,
                spacing: { before: 600, after: 300 },
                style: 'paragraphStyle',
            }),
            new Paragraph({
                text: `Der Lehrgang unterteilt sich in vier Module. Nach dem Umrechnungsschlüssel der Akademie
für juristische Fachseminare beträgt die Lernzeit bei autodidaktischer Aneignung pro Modul
mindestens ${
                    courseParticipation.bookedCourse.targetReadingTime /
                    courseParticipation.bookedCourse.modules.length
                } Zeitstunden.`,
                spacing: { after: 600 },
                style: 'paragraphStyle',
            }),
        ];
    }

    createLearnControlTableHeader(
        moduleInfo: LearningModuleDocumentInfo,
        courseParticipation: CustomerDetailsCourseParticipation
    ): TableRow {
        //
        return new TableRow({
            height: {
                value: 400,
                rule: HeightRule.ATLEAST,
            },
            // tableHeader: true,
            children: [
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    borders: noBorderConf,
                    margins: {
                        left: 100,
                        right: 100,
                    },
                    children: [
                        new Paragraph({
                            text: `Lehrinhalte gem. § 2, 14b FAO`,
                            style: 'table-header-footer',
                        }),
                        new Paragraph({
                            text: `${
                                courseParticipation.bookedCourse.description
                            } – ${
                                courseParticipation.bookedCourse.modules.find(
                                    ({ id }) => id === moduleInfo.moduleId
                                )?.name ?? 'Modul'
                            }`,
                            style: 'table-header-footer',
                        }),
                    ],
                    shading: {
                        fill: 'e1e1e1',
                    },
                    columnSpan: 2,
                }),
                new TableCell({
                    verticalAlign: VerticalAlign.CENTER,
                    borders: noBorderConf,

                    children: [
                        new Paragraph({
                            text:
                                'Autoren des Verlags Wolters Kluwer\n' +
                                'Deutschland GmbH; § 6 Abs. 2b FAO',
                            style: 'table-header-footer',
                        }),
                    ],
                    shading: {
                        fill: 'e1e1e1',
                    },
                }),
            ],
        });
    }

    getModuleNodeTitles(
        node: LearningModuleDocumentInfo | Chapter | Section,
        depth: number,
        isFirstLevel = true
    ): TitleTableRowData[] {
        if (depth > MAX_TITLE_DEPTH) {
            return [];
        }
        let titles: TitleTableRowData[] = [];
        if ('title' in node) {
            console.log(
                'bibliographies' in node && node.bibliographies.length > 0
                    ? node.bibliographies.map(bib => bib.author).join(' / ')
                    : node.title + ' not found',
                node
            );
            titles.push({
                numbering: this.sectionNumberingPipe.transform(node.title),
                title: this.sectionTitlePipe.transform(node.title),
                author:
                    'bibliographies' in node && node.bibliographies.length > 0
                        ? _.uniq(
                              _.flatten(
                                  node.bibliographies.map(bib =>
                                      bib.author.split(' / ')
                                  )
                              )
                          )
                              .filter(name => name.length > 1)
                              .join(' / ')
                        : '',
                isChapter: isFirstLevel,
            });
        }
        const isFirst = titles.length === 0;
        const childArrayName =
            this.moduleDocumentHelperService.getNodeChildArrayName(node);
        if (childArrayName && childArrayName !== 'content') {
            node[childArrayName].forEach(childNode => {
                titles = titles.concat(
                    this.getModuleNodeTitles(childNode, depth + 1, isFirst)
                );
            });
        }
        return titles;
    }

    createTitleRow(title: TitleTableRowData): TableRow {
        return new TableRow({
            children: [
                new TableCell({
                    borders: topBorderConf,
                    verticalAlign: VerticalAlign.CENTER,
                    margins: {
                        left: 100,
                        right: 100,
                    },
                    children: [
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: title.isChapter
                                        ? `${title.numbering}.`
                                        : '',
                                    bold: title.isChapter,
                                }),
                            ],
                            style: 'table-content',
                            alignment: AlignmentType.CENTER,
                        }),
                    ],
                }),
                new TableCell({
                    borders: topBorderConf,
                    verticalAlign: VerticalAlign.CENTER,
                    margins: {
                        left: 100,
                        right: 100,
                        bottom: 30,
                        top: 30,
                    },
                    children: [
                        new Paragraph({
                            children: [
                                new TextRun({
                                    text: title.title,
                                    bold: title.isChapter,
                                }),
                            ],
                            style: 'table-content',
                        }),
                    ],
                }),
                new TableCell({
                    borders: topBorderConf,
                    verticalAlign: VerticalAlign.CENTER,
                    margins: {
                        left: 100,
                        right: 100,
                        bottom: 30,
                        top: 30,
                    },
                    children: [
                        new Paragraph({
                            children: [new TextRun(title.author)],
                            style: 'table-content',
                        }),
                    ],
                }),
            ],
        });
    }

    private createLearnControlTableFooter(
        courseParticipation: CustomerDetailsCourseParticipation,
        index: number
    ): TableRow[] {
        return [
            new TableRow({
                height: {
                    value: 400,
                    rule: HeightRule.ATLEAST,
                },
                children: [
                    new TableCell({
                        borders: noBorderConf,
                        verticalAlign: VerticalAlign.CENTER,
                        columnSpan: 3,
                        children: [new Paragraph('')],
                    }),
                ],
            }),
            new TableRow({
                tableHeader: true,
                children: [
                    new TableCell({
                        borders: noBorderConf,
                        verticalAlign: VerticalAlign.CENTER,
                        columnSpan: 3,
                        shading: {
                            fill: 'e1e1e1',
                        },
                        margins: {
                            left: 100,
                            right: 100,
                            bottom: 30,
                            top: 30,
                        },
                        children: [
                            new Paragraph({
                                text: `Die Bearbeitungszeit von mindestens ${
                                    courseParticipation.bookedCourse
                                        .targetReadingTime /
                                    courseParticipation.bookedCourse.modules.filter(
                                        m => m.type === LearnModuleType.Module
                                    ).length
                                } Zeitstunden wurde erfüllt (s. auch Dokumentation der Lernzeit)`,
                                style: 'table-header-footer',
                            }),
                        ],
                    }),
                ],
            }),
            new TableRow({
                tableHeader: true,

                children: [
                    new TableCell({
                        verticalAlign: VerticalAlign.CENTER,
                        borders: topBorderConf,
                        columnSpan: 3,
                        margins: {
                            left: 100,
                            right: 100,
                            bottom: 30,
                            top: 30,
                        },
                        shading: {
                            fill: 'e1e1e1',
                        },
                        children: [
                            new Paragraph({
                                text: `Die abschließende Lernkontrolle ${this.numberToNumberingPipe.transform(
                                    index,
                                    'upperRomanNumerals'
                                )} wurde bestanden`,
                                style: 'table-header-footer',
                            }),
                        ],
                    }),
                ],
            }),
        ];
    }

    private createEducationCertificateLernContentSectionTables(
        moduleInfos: LearningModuleDocumentInfo[],
        courseParticipation: CustomerDetailsCourseParticipation,
        customer: CustomerBaseData
    ): (Table | Paragraph)[] {
        let returnContent: (Table | Paragraph)[] = [];
        moduleInfos
            .sort((m1, m2) => m1.sequentialNumber - m2.sequentialNumber)
            .forEach((moduleInfo, index) => {
                const titles = this.getModuleNodeTitles(moduleInfo, 1);
                let tableRows: TableRow[] = [
                    this.createLearnControlTableHeader(
                        moduleInfo,
                        courseParticipation
                    ),
                ];
                titles.forEach(title => {
                    tableRows.push(this.createTitleRow(title));
                });

                tableRows = tableRows.concat(
                    this.createLearnControlTableFooter(
                        courseParticipation,
                        index + 1
                    )
                );
                returnContent.push(
                    new Table({
                        rows: tableRows,
                        columnWidths: [500, 5000, 3500],
                        width: {
                            type: WidthType.PERCENTAGE,
                            size: 100,
                        },
                        borders: topBorderConf,
                    })
                );
                returnContent.push(
                    new Paragraph({
                        text: '',
                        spacing: { before: 100 },
                        style: 'paragraphStyle',
                    })
                );
            });
        returnContent = returnContent.concat([
            new Table({
                columnWidths: [4500, 4500],
                width: {
                    type: WidthType.PERCENTAGE,
                    size: 100,
                },
                rows: [
                    new TableRow({
                        children: [
                            new TableCell({
                                verticalAlign: VerticalAlign.TOP,
                                borders: noBorderConf,
                                children: [...this.createSignFooter()],
                            }),
                            new TableCell({
                                verticalAlign: VerticalAlign.TOP,
                                borders: noBorderConf,
                                children: [
                                    new Paragraph({
                                        text: '...............................................................................',
                                        spacing: { before: 550 },
                                        style: 'smallParagraphStyle',
                                    }),
                                    new Paragraph({
                                        text: customer.displayName,
                                        style: 'smallParagraphStyle',
                                    }),
                                    new Paragraph({
                                        text: 'versichert sämtliche Lehrinhalte während o. g. Zeitraum',
                                        style: 'smallParagraphStyle',
                                    }),
                                    new Paragraph({
                                        text: 'selbstständig und ohne fremde Hilfe bearbeitet zu haben.',
                                        style: 'smallParagraphStyle',
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ]);
        return returnContent;
    }

    private getMonthMapOfTimeExpenditures(
        timeExpenditures: TimeExpenditure[]
    ): Map<string, number> {
        const monthMap = new Map<string, number>(); //['monthCode' => totalTimeRead]
        timeExpenditures.forEach(te => {
            const monthCode = this.datepipe
                .transform(Date.parse(te.lastRead), 'MMMM y', 'de_DE')
                .replace('.', '');
            if (monthMap.has(monthCode)) {
                monthMap.set(monthCode, monthMap.get(monthCode) + te.duration);
            } else {
                monthMap.set(monthCode, te.duration);
            }
        });
        return monthMap;
    }

    private createLearningTimeTable(
        sortedTimeExpenditures: TimeExpenditure[]
    ): Table {
        const monthMap = this.getMonthMapOfTimeExpenditures(
            sortedTimeExpenditures
        );

        const timeRows: TableRow[] = [];
        monthMap.forEach((duration, month) => {
            timeRows.push(
                new TableRow({
                    height: {
                        value: 400,
                        rule: HeightRule.ATLEAST,
                    },
                    children: [
                        new TableCell({
                            borders: topBorderConf,
                            verticalAlign: VerticalAlign.CENTER,
                            margins: {
                                left: 30,
                            },
                            children: [
                                new Paragraph({
                                    text: month,
                                    style: 'table-content',
                                }),
                            ],
                        }),
                        new TableCell({
                            borders: topBorderConf,
                            verticalAlign: VerticalAlign.CENTER,
                            margins: {
                                right: 30,
                            },
                            children: [
                                new Paragraph({
                                    text: `${Math.floor(
                                        duration / 3600
                                    )}h ${Math.floor(
                                        (duration -
                                            Math.floor(duration / 3600) *
                                                3600) /
                                            60
                                    )}m`,
                                    alignment: AlignmentType.END,
                                    style: 'table-content',
                                }),
                            ],
                        }),
                    ],
                })
            );
        });

        return new Table({
            columnWidths: [1500, 1500],
            width: {
                type: WidthType.PERCENTAGE,
                size: 50,
            },
            rows: [
                new TableRow({
                    height: {
                        value: 400,
                        rule: HeightRule.ATLEAST,
                    },
                    children: [
                        new TableCell({
                            borders: noBorderConf,
                            verticalAlign: VerticalAlign.CENTER,
                            margins: {
                                left: 30,
                            },
                            columnSpan: 2,
                            children: [
                                new Paragraph({
                                    text: 'Dokumentation der absoluten Lernzeit',
                                    style: 'table-header-footer',
                                }),
                            ],
                        }),
                    ],
                }),
                ...timeRows,
            ],
        });
    }

    private async createEducationCertificateApprovalPage(
        courseParticipation: CustomerDetailsCourseParticipation
    ): Promise<(Paragraph | Table)[]> {
        return [
            new Paragraph({
                text: 'Zertifizierung & Zulassung',
                style: 'ak-heading-1',
                spacing: { before: 1700, after: 800 },
            }),
            new Paragraph({ text: 'durch die', style: 'ak-heading-3' }),
            new Paragraph({
                text: 'Staatliche Zentralstelle für Fernunterricht',
                style: 'ak-heading-2',
            }),
            new Paragraph({
                text: `Die für die Länder zuständige Behörde – Staatliche Zentralstelle für Fernunterricht – bestätigt, dass für den Fernlehrgang ${
                    typeof courseParticipation.bookedCourse
                        .associatedLegalArea !== 'string'
                        ? courseParticipation.bookedCourse.associatedLegalArea
                              .name
                        : ''
                }, sämtliche Voraussetzungen der Fachanwaltsordnung vorliegen – dies sind insbesondere:`,
                style: 'paragraphStyle',
                spacing: { before: 600, after: 800 },
            }),
            new Table({
                width: {
                    type: WidthType.PERCENTAGE,
                    size: 100,
                },
                columnWidths: [190, 1000],
                borders: noBorderConf,
                rows: [
                    new TableRow({
                        children: [
                            new TableCell({
                                verticalAlign: VerticalAlign.CENTER,
                                borders: noBorderConf,
                                children: [
                                    new Paragraph({
                                        children: [
                                            new ImageRun({
                                                data: await this.loadImage(
                                                    'assets/certificateSign.jpg'
                                                ).toPromise(),
                                                transformation: {
                                                    width: 80,
                                                    height: 80,
                                                },
                                            }),
                                        ],
                                    }),
                                ],
                            }),
                            new TableCell({
                                verticalAlign: VerticalAlign.CENTER,
                                borders: noBorderConf,
                                children: [
                                    new Paragraph({
                                        text: '− die Zulassungsvoraussetzungen nach § 12 Abs. 1 FernUSG',
                                        style: 'paragraphStyle',
                                    }),
                                    new Paragraph({
                                        text: '− die Vorbereitung auf die schriftlichen Prüfungen gem. §§ 4, 4a FAO sowie',
                                        style: 'paragraphStyle',
                                    }),
                                    new Paragraph({
                                        text: '− die fachanwaltsspezifische Eignung der Unterrichtsmaterialien gem. §§ 4, 14b FAO',
                                        style: 'paragraphStyle',
                                    }),
                                ],
                            }),
                        ],
                    }),
                    new TableRow({
                        children: [
                            new TableCell({
                                verticalAlign: VerticalAlign.CENTER,
                                borders: noBorderConf,
                                children: [],
                            }),
                            new TableCell({
                                verticalAlign: VerticalAlign.CENTER,
                                borders: noBorderConf,
                                children: [
                                    new Paragraph({
                                        text: `Zul-Nr. ${this.approvalNumber}`,
                                        style: 'paragraphStyleBold',
                                        spacing: { before: 100 },
                                    }),
                                ],
                            }),
                        ],
                    }),
                ],
            }),
        ];
    }

    createEducationCertificateLearningTimeSectionHeader(
        customer: CustomerBaseData,
        sortedTimeExpenditures: TimeExpenditure[]
    ): (Paragraph | Table)[] {
        const firstMonthYear = this.datepipe.transform(
            new Date(sortedTimeExpenditures[0].lastRead),
            'MMMM yyyy',
            'de_DE'
        );
        const lastMonthYear = this.datepipe.transform(
            new Date(
                sortedTimeExpenditures[
                    sortedTimeExpenditures.length - 1
                ].lastRead
            ),
            'MMMM yyyy',
            'de_DE'
        );
        return [
            new Paragraph({
                text: 'Nachweis der Lernzeit',
                style: 'ak-heading-1',
                spacing: { before: 1700, after: 800 },
            }),
            ...this.createCustomerNameHeader(customer),
            new Paragraph({
                spacing: { before: 600, after: 300 },
                text: `absolvierte den Fachanwaltslehrgang in der Zeit von ${firstMonthYear} bis ${lastMonthYear}.`,
                style: 'paragraphStyle',
            }),
            new Paragraph({
                spacing: { after: 300 },
                text: 'Jedes Lehrgangsjahr weist mindestens 15 Zeitstunden Lernzeit auf; §§ 4 Abs. 2, 15 Abs. 3 FAO. Das Monitoring ergab keine Auffälligkeiten.',
                style: 'paragraphStyle',
            }),
            new Paragraph({
                spacing: { after: 600 },
                text: 'Die erforderliche Gesamtdauer von insgesamt 120 Zeitstunden gem. § 4 Abs. 1 FAO wurde erreicht (erfasst wurde ausschließlich die Lernzeit anhand der Lehrinhalte gem. 14b FAO ohne Lern- und Leistungskontrollen) und gliedert sich wie folgt:',
                style: 'paragraphStyle',
            }),
        ];
    }

    public async createEducationCourseCertificate(
        customer: CustomerListData,
        courseParticipation: CustomerDetailsCourseParticipation,
        courseExam: CustomerDetailsExam,
        moduleInfos: LearningModuleDocumentInfo[],
        timeExpenditures: TimeExpenditure[]
    ) {
        const style: IStylesOptions = {
            paragraphStyles: [
                {
                    id: 'paragraphStyle',
                    name: 'AK Jura Paragraph',
                    basedOn: 'Normal',
                    next: 'Normal',
                    run: {
                        color: '000000',
                        font: 'Adelle Sans Light',
                    },
                },
                {
                    id: 'paragraphStyleBold',
                    name: 'AK Jura Paragraph bold',
                    basedOn: 'Normal',
                    next: 'Normal',
                    run: {
                        size: 16,
                        color: '000000',
                        font: 'Adelle Sans Semibold',
                    },
                },
                {
                    id: 'smallParagraphStyle',
                    name: 'Small AK Jura Paragraph',
                    basedOn: 'Normal',
                    next: 'Normal',
                    run: {
                        size: 16,
                        color: '000000',
                        font: 'Adelle Sans Light',
                    },
                },
                {
                    id: 'exam-table-header',
                    name: 'Exam Table Header',
                    basedOn: 'Normal',
                    next: 'Normal',
                    run: {
                        size: 20, // halfPts RTFM!!!!
                        font: 'Adelle Sans Semibold',
                        color: '000000',
                    },
                },
                {
                    id: 'exam-table-content',
                    name: 'Exam Table Content',
                    basedOn: 'Normal',
                    next: 'Normal',
                    run: {
                        size: 20, // halfPts RTFM!!!!
                        font: 'Adelle Sans Light',
                        color: '000000',
                    },
                },
                {
                    id: 'table-header-footer',
                    name: 'Table Header and Footer',
                    basedOn: 'Normal',
                    next: 'Normal',
                    run: {
                        size: 14, // halfPts RTFM!!!!
                        font: 'Adelle Sans Semibold',
                        color: '000000',
                    },
                },
                {
                    id: 'table-content',
                    name: 'Table Content',
                    basedOn: 'Normal',
                    next: 'Normal',
                    run: {
                        size: 14, // halfPts RTFM!!!!
                        font: 'Adelle Sans Light',
                        color: '000000',
                    },
                },
                {
                    id: 'ak-heading-1',
                    name: 'Heading-1',
                    basedOn: 'Normal',
                    next: 'Normal',
                    run: {
                        size: 40, // halfPts RTFM!!!!
                        font: 'Adelle Sans Semibold',
                        color: '000000',
                    },
                },
                {
                    id: 'ak-heading-2',
                    name: 'Heading-2',
                    basedOn: 'Normal',
                    next: 'Normal',
                    run: {
                        size: 28, // halfPts RTFM!!!!
                        font: 'Adelle Sans Semibold',
                        color: '000000',
                    },
                },
                {
                    id: 'ak-heading-3',
                    name: 'Heading-3',
                    basedOn: 'Normal',
                    next: 'Normal',
                    run: {
                        size: 18, // halfPts RTFM!!!!
                        font: 'Adelle Sans Light',
                        color: '000000',
                    },
                },
            ],
        };
        const doc = new Document({
            styles: style,
            sections: [
                {
                    properties: {
                        type: SectionType.NEXT_PAGE,
                    },
                    children: this.createEducationCertificateFrontpageSection(
                        customer,
                        courseParticipation
                    ),
                },
                {
                    properties: {
                        type: SectionType.NEXT_PAGE,
                    },
                    children: this.createEducationCertificateExamSectionStart(
                        customer,
                        courseExam,
                        courseParticipation
                    ),
                },
                {
                    properties: {
                        type: SectionType.CONTINUOUS,
                    },
                    children: [this.createExamTable(courseExam)],
                },
                {
                    properties: {
                        type: SectionType.CONTINUOUS,
                    },
                    children: this.createEducationCertificateExamSectionEnd(),
                },
                {
                    properties: {
                        type: SectionType.NEXT_PAGE,
                    },
                    children:
                        this.createEducationCertificateLernContentSectionHeader(
                            customer,
                            courseParticipation
                        ),
                },
                {
                    properties: {
                        type: SectionType.CONTINUOUS,
                    },
                    children:
                        this.createEducationCertificateLernContentSectionTables(
                            moduleInfos,
                            courseParticipation,
                            customer
                        ),
                },
                {
                    properties: {
                        type: SectionType.NEXT_PAGE,
                    },
                    children:
                        this.createEducationCertificateLearningTimeSectionHeader(
                            customer,
                            timeExpenditures.sort((d1, d2) => {
                                return (
                                    new Date(d1.lastRead).getTime() -
                                    new Date(d2.lastRead).getTime()
                                );
                            })
                        ),
                },
                {
                    properties: {
                        type: SectionType.CONTINUOUS,
                    },
                    children: [
                        this.createLearningTimeTable(
                            timeExpenditures.sort((d1, d2) => {
                                return (
                                    new Date(d1.lastRead).getTime() -
                                    new Date(d2.lastRead).getTime()
                                );
                            })
                        ),
                        ...this.createSignFooter(),
                    ],
                },
                {
                    properties: {
                        type: SectionType.NEXT_PAGE,
                    },
                    children: await this.createEducationCertificateApprovalPage(
                        courseParticipation
                    ),
                },
            ],
        });

        const fileName = `Zertifikat_${courseParticipation.bookedCourse.description}_${customer.firstName}_${customer.lastName}.docx`;
        Packer.toBlob(doc)
            .then(blob => {
                saveAs(blob, fileName);
            })
            .catch(x => console.log('error', x));
    }
}
